import { MESSAGE_CHANNEL_TYPES } from "@whatslly/types/instant-messaging/messagesEmitter";

export const INCIDENTS_CHANNELS = [...MESSAGE_CHANNEL_TYPES, "slack", "discord", "teams", "chatgpt"] as const;
export type IncidentsChannel = (typeof INCIDENTS_CHANNELS)[number];

export const IncidentsChannel = {
  WHATSAPP_WEB: "whatsAppWeb",
  WHATSAPP_API: "whatsAppApi",
  TELEGRAM: "telegram",
  SMS: "sms",
  SLACK: "slack",
  DISCORD: "discord",
  TEAMS: "teams",
  CHATGPT: "chatgpt",
} as const;
